import { Form, Select } from 'antd'
import SearchItem from './Search'

const actions = [
  {
    label: 'Buscar Conhecimento',
    value: 'SEARCH',
  },
]

export default function KnowledgeForm({
  form,
  parameters,
  assistantID,
  fieldName,
}) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

  if (!assistantID) return <></>

  return (
    <>
      <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
        <Select options={actions} placeholder={'Selecione o tipo de ação'} />
      </Form.Item>
      {type === 'SEARCH' && (
        <SearchItem
          fieldName={fieldName}
          parameters={parameters}
          assistantID={assistantID}
        />
      )}
    </>
  )
}
